import React, { useEffect, useState } from 'react';
import { warName } from '../..';

function importScriptAndCSS(callback) {
    if (window.avvpl != null) {
        return;
    }
    
    const script = document.createElement('script');
    script.async = 1;
    const apiDomain = process.env.REACT_APP_API_DOMAIN;
    script.src = `${apiDomain}/${warName}/content/js/streaming/avvpl-player.js`;
    script.onload = callback;
    const node = document.getElementsByTagName('script')[0];
    node.parentNode.insertBefore(script, node);

    const css = document.createElement('link');
    css.setAttribute('rel', 'stylesheet')
    css.setAttribute('href', `${apiDomain}/${warName}/content/js/streaming/style/styles.css`);
    document.head.appendChild(css);
}

export default function RadarStreamingFetcher(props) {
    const [loaded, setLoaded] = useState(window.avvpl != null);

    useEffect(() => {
        importScriptAndCSS(() => setLoaded(true));

        return () => {
            window.avvpl = null;
        }

    }, []);

    if (loaded) {
        return props.children;
    }

    return <></>;
}
